import { render, staticRenderFns } from "./FormSubmissionsExport.vue?vue&type=template&id=49a8ad9d&scoped=true&"
import script from "./FormSubmissionsExport.vue?vue&type=script&lang=js&"
export * from "./FormSubmissionsExport.vue?vue&type=script&lang=js&"
import style0 from "./FormSubmissionsExport.vue?vue&type=style&index=0&id=49a8ad9d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a8ad9d",
  null
  
)

export default component.exports